import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant,{Lazyload} from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import Dialog from 'vant'

Vue.prototype.axios = axios
Vue.prototype.url = "https://api.foodslover.cn"

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Dialog)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
